'use client';

import React from 'react';

export default function Loading() {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: '#0a0a0c',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      gap: '1.5rem'
    }}>
      <div style={{ 
        position: 'relative', 
        width: '100px', 
        height: '100px', 
        minWidth: '100px',
        minHeight: '100px',
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}>
        <img 
          src="/logo_v2.png" 
          alt="Logo" 
          style={{ 
            width: '60px', 
            height: '60px', 
            objectFit: 'contain', 
            animation: 'loading-pulse 2s ease-in-out infinite' 
          }} 
        />
        {/* Background track */}
        <div style={{
          position: 'absolute',
          inset: 0,
          border: '3px solid rgba(16, 185, 129, 0.1)',
          borderRadius: '50%',
        }} />
        {/* Animated spinner */}
        <div style={{
          position: 'absolute',
          inset: 0,
          border: '3px solid transparent',
          borderTopColor: 'var(--accent)',
          borderRadius: '50%',
          animation: 'loading-spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite'
        }} />
      </div>
      <div style={{ 
        fontSize: '1.25rem', 
        fontWeight: 700, 
        color: 'var(--accent)',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        opacity: 0.8
      }}>
        MyMoneyMagic
      </div>
    </div>
  );
}
